import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62bb4dd4")

_pushScopeId("data-v-62bb4dd4")
const _hoisted_1 = { class: "iconbutton" }
const _hoisted_2 = { class: "name" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_icon = _resolveComponent("van-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.img)
      ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          round: "",
          width: "0.66667rem",
          height: "0.66667rem",
          src: _ctx.img
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    (!_ctx.img && _ctx.icon)
      ? (_openBlock(), _createBlock(_component_van_icon, {
          key: 1,
          name: _ctx.icon,
          class: _ctx.iconClass,
          color: _ctx.iconColor
        }, null, 8, ["name", "class", "color"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.name), 1)
  ]))
})